// extracted by mini-css-extract-plugin
export default {"container":"CheckoutSuccess_container__d6VwI"};